"use client"

import styled from "@emotion/styled"
import { Box, Button, Typography } from "@mui/material"
import Image from "next/image"
import { useInView } from "react-intersection-observer"
import { useInViewConfig, useTransitionUpStyles } from "ui"
import { colors, mediaQueries, sizes } from "ui/theme/theme"

export const StyledResultContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 90%;
  gap: ${sizes.baseTriple};
  padding: ${sizes.baseTriple};
  h3 {
    color: ${colors.black};
  }
  span {
    text-align: center;
  }
`

const StyledImageWrapper = styled(Box)`
  position: relative;
  width: 120px;
  height: 120px;
`

const StyledButton = styled(Button)`
  position: absolute;
  top: 0;
  right: -${sizes.baseTriple};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  padding: 0;
  ${mediaQueries.desktopM} {
    top: -${sizes.baseQuadric};
    right: -${sizes.baseQuadric};
    font-size: 20px;
  }
`
const StyledTextContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${sizes.baseSingle};
`
const StyledRetry = styled(Typography)`
  text-decoration: underline;
  cursor: pointer;
`

interface FailureStateProps {
  data: {
    failImage: {
      mediaItems: Array<{
        url: string
      }>
    }
    failTitle: {
      value: string
    }
    failText: {
      value: string
    }
    retryFailText: {
      value: string
    }
    serviceFailText: {
      value: string
    }
  }
  onRetry?: () => void
}

const FailureState = ({ data, onRetry }: FailureStateProps) => {
  const { ref, inView } = useInView(useInViewConfig)
  const transitionStyles = useTransitionUpStyles(inView)

  const { failImage, failTitle, failText, retryFailText, serviceFailText } =
    data

  return (
    <StyledResultContainer ref={ref} style={transitionStyles}>
      <StyledButton
        variant="ghost"
        onClick={() => {
          if (onRetry) {
            onRetry()
          }
        }}
      >
        X
      </StyledButton>
      {failImage?.mediaItems?.length > 0 && (
        <StyledImageWrapper>
          <Image
            src={failImage.mediaItems[0].url}
            alt="Failure"
            fill
            style={{ objectFit: "contain" }}
          />
        </StyledImageWrapper>
      )}
      {failTitle?.value && (
        <Typography variant="h4">{failTitle.value}</Typography>
      )}
      {failText?.value && (
        <Typography variant="body3">{failText.value}</Typography>
      )}
      {(retryFailText?.value || serviceFailText?.value) && (
        <StyledTextContainer>
          <StyledRetry variant="body3" onClick={onRetry}>
            {retryFailText?.value}
          </StyledRetry>
          <Typography variant="body3">{serviceFailText?.value}</Typography>
        </StyledTextContainer>
      )}
    </StyledResultContainer>
  )
}

export default FailureState
